import axios from "@/config/httpConfig";
// 发布文章接口
export function publishArticle(data) {
    return axios.post("/knowledge/publishArticle", data);
}
